class CartDrawer extends HTMLElement {
  static isBusy = false;

  static setBusy(state) {
    CartDrawer.isBusy = !!state;
    document.body.classList.toggle('freebie-busy', CartDrawer.isBusy);
  }

  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', async (event) => {
      event.preventDefault();
      this.open(cartLink)

      const cartProducts = document.querySelectorAll("#CartDrawer-CartItems tr");
      
      const productTitlesList = []
      cartProducts.forEach((eachProduct) => {
        const productTitle = eachProduct.querySelector(".cart-item__details a").textContent;
        productTitlesList.push(productTitle);
      })

      const cartValue = document.querySelector(".cart-drawer__footer .totals__subtotal-value span").textContent;
      const clevertapData = {
        Products_In_Cart: cartProducts.length,
        Product_Names: productTitlesList,
        Cart_Value: cartValue,
        Current_Page: cartLink.dataset.currentPage
      }

      dataLayer.push({
        event: "Cart_Viewed",
        Products_In_Cart: cartProducts.length,
        Product_Names: productTitlesList,
        Cart_Value: cartValue,
        Current_Page: cartLink.dataset.currentPage,
        clevertap: clevertapData
      });
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // pushing state to handle back button for cart open
    const url = new URL(location);
    if (location.href.indexOf('cartOpen=true') == -1) {
      url.searchParams.set("cartOpen", "true");
      window.history.pushState({'cart':'open'}, "", url);
    }
    
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    this.cartUpdate();    
  }
  
  async cartUpdate(){
    const cartJson = await fetch('/cart.json').then( response => response.json());
    const cartItemCount = Number(document.querySelector(".cart-count-bubble span:first-child").innerText);
    
    if (cartJson.item_count !== cartItemCount) {
      let cartElemopen = document.querySelector('cart-drawer');
      fetch(`/?sections=${cartElemopen.getSectionsToRender().map((section) => section.id).toString()}`)
      .then(response => response.json())
      .then(data => cartElemopen.renderContents({sections: data}))
    } 

    const cartDrawer = document.querySelector('cart-drawer');
    const cartInner = cartDrawer.querySelector(".drawer__inner");
    const cartPrice = parseInt(cartInner.dataset.cartPrice);
    const freebieThreshold = parseInt(cartInner.dataset.freebieThreshold);

    const confetti = this.querySelector('#e0DQ82qcIov1');
    if (confetti) {
      if (cartPrice < freebieThreshold) {
        confetti.classList.add('small-confetti');
      }
      else {
        confetti.classList.remove('small-confetti');
      }
    }
  }

  close() {
    // remove Url after close of cart
    let currentPageUrl = window.location.href.replace(/[?&]cartOpen=true/g, '');
    window.history.replaceState({}, document.title, currentPageUrl);
    
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, showCart) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    document.dispatchEvent(new CustomEvent('cart:refresh-sticky-bar'));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (document.querySelector('quantity-message') && window.innerWidth <= 768) {
        setTimeout(() => {
          let confettiShooterCount = document.querySelector('quantity-message')?.querySelector('noscript').getAttribute('data-cart-count');   
          if (confettiShooterCount >= 1 && !document.querySelector("collection-progressbar")) {
            this.open();
          }
        }, 2000);
      }
      else if (!document.querySelector("collection-progressbar")){
        showCart?null:this.open();
      } 
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    const sections = [
    {
      id: 'cart-drawer',
      selector: '#CartDrawer'
    },
    {
      id: 'cart-icon-bubble'
    }
  ];

  if (document.getElementById('quantity-message')) {
    sections.push({
      id: 'quantity-message'
    });
  }

  return sections;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  addFreebie() {
    fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const cartAjax = document.querySelector(".cart-ajax");
      if (!cartAjax) {
        handleCart(cart);
        return;
      }

      // ------------------ COLLECT ALL ENABLED OFFER VARIANT IDS ------------------
      const enabledOfferVariantIds = new Set();

      // Price-based offers
      for (let i = 1; i <= 4; i++) {
        (cartAjax.getAttribute(`data-eligible-variantids-${i}`)?.split(",") || [])
          .map(v => v.trim())
          .forEach(v => enabledOfferVariantIds.add(v));
      }

      // Qty-based offers
      [
        "data-eligible-qty-variantsids",
        "data-eligible-qty-variantsids-two",
        "data-eligible-qty-variantsids-three",
        "data-eligible-qty-variantsids-four",
        "data-eligible-qty-variantsids-five",
        "data-eligible-qty-variantsids-six",
        "data-eligible-qty-variantsids-seven",
        "data-eligible-qty-variantsids-eight",
      ].forEach(attr => {
        (cartAjax.getAttribute(attr)?.split(",") || [])
          .map(v => v.trim())
          .forEach(v => enabledOfferVariantIds.add(v));
      });

      // Offer 13 — Special product freebie
      const specialFreebieVidGlobal = cartAjax.getAttribute("data-special-freebie-vid")?.trim();
      if (specialFreebieVidGlobal) enabledOfferVariantIds.add(specialFreebieVidGlobal);

      // Offer 13 — Normal fallback freebie
      const normalFreebieVidGlobal = cartAjax.getAttribute("data-normal-freebie-vid")?.trim();
      if (normalFreebieVidGlobal) enabledOfferVariantIds.add(normalFreebieVidGlobal);

      // ------------------ FILTER FREEBIES IN CART ------------------
      const cartFreebies = cart.items.filter(
        item => item.properties?._freebieLineItem === "true"
      );

      // ------------------ FIND FREEBIES THAT ARE NO LONGER IN ENABLED OFFERS ------------------
      const freebiesToRemove = cartFreebies.filter(item => {
        const id = String(item.id).trim();
        return !enabledOfferVariantIds.has(id); // remove only if freebie not in enabled offers
      });

      // ------------------ IF NOTHING TO REMOVE ------------------
      if (!freebiesToRemove.length) {
        handleCart(cart);
        return;
      }

      // ------------------ REMOVE INVALID FREEBIES ------------------
      const updates = {};
      freebiesToRemove.forEach(item => {
        updates[item.key] = 0;
      });

      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      })
        .then(res => res.json())
        .then((updatedCart) => {
          handleCart(updatedCart); // call main freebie logic after cleaning
        })
        .catch(err => {
          console.error("Failed to remove invalid freebies:", err);
          handleCart(cart); // fallback
        });
    })
    .catch(() => CartDrawer.setBusy(false));

    async function handleCart(cart) {
      /* ------------------ CART TOTALS ------------------ */
      let eligibleCartPrice = 0;

      cart.items.forEach((item) => {
        if (!item.properties?.affiliateProduct) {
          eligibleCartPrice += item.final_line_price;
        }
      });

      const cartSubtotal = eligibleCartPrice / 100;

      /* ------------------ TAG / QTY COUNT ------------------ */
      // let tagPresenceCount = 0;

      // document
      //   .querySelectorAll("cart-drawer .cart-item")
      //   .forEach((item) => {
      //     const tags = item.dataset.variantTags;
      //     if (!tags) return;

      //     item.querySelectorAll("quantity-input input").forEach((input) => {
      //       tagPresenceCount += parseInt(input.value || 0);
      //     });
      //   });

      const cartAjax = document.querySelector(".cart-ajax");
      if (!cartAjax) { CartDrawer.setBusy(false); return; }

      const cartVariantIds = cart.items.map((i) => String(i.id));

      const currentFreebies = cart.items.filter(
        (item) => item.properties?._freebieLineItem === "true"
      );

      let variantsToAdd = [];
      let variantsToRemove = [];

      /* ======================================================
        PRICE BASED OFFERS (1–4)
      ====================================================== */
      for (let i = 1; i <= 4; i++) {
        const threshold = Number(
          cartAjax.getAttribute(`data-eligible-price-${i}`)
        );
        const count = Number(
          cartAjax.getAttribute(`data-eligible-count-${i}`)
        );
        const variants =
          cartAjax
            .getAttribute(`data-eligible-variantids-${i}`)
            ?.split(",")
            .map((v) => v.trim()) || [];

        if (!threshold || !count || !variants.length) continue;

        const thresholdMet = cartSubtotal >= threshold;

        const offerFreebiesInCart = currentFreebies.filter((item) =>
          variants.includes(String(item.id))
        );

        if (!thresholdMet) {
          offerFreebiesInCart.forEach((item) => {
            variantsToRemove.push(item.key);
          });
          continue;
        }

        if (offerFreebiesInCart.length >= count) continue;

        const needed = count - offerFreebiesInCart.length;
        const usedIds = offerFreebiesInCart.map((i) => String(i.id));

        const availableFallbacks = await getAvailableVariants(
          variants.filter((id) => !usedIds.includes(id)),
          needed,
          cartVariantIds
        );

        variantsToAdd.push(...availableFallbacks);
      }

      /* ======================================================
        QTY BASED OFFERS (1–4)
      ====================================================== */
      const qtyOffers = [
        {
          thresholdAttr: "data-eligible-qty",
          variantsAttr: "data-eligible-qty-variantsids",
          countAttr: "data-eligible-qty-count",
          tagsAttr: "data-eligible-qty-tags",
        },
        {
          thresholdAttr: "data-eligible-qty-two",
          variantsAttr: "data-eligible-qty-variantsids-two",
          countAttr: "data-eligible-qty-count-two",
          tagsAttr: "data-eligible-qty-tags-two",
        },
        {
          thresholdAttr: "data-eligible-qty-three",
          variantsAttr: "data-eligible-qty-variantsids-three",
          countAttr: "data-eligible-qty-count-three",
          tagsAttr: "data-eligible-qty-tags-three",
        },
        {
          thresholdAttr: "data-eligible-qty-four",
          variantsAttr: "data-eligible-qty-variantsids-four",
          countAttr: "data-eligible-qty-count-four",
          tagsAttr: "data-eligible-qty-tags-four",
        },
        {
          thresholdAttr: "data-eligible-qty-five",
          variantsAttr: "data-eligible-qty-variantsids-five",
          countAttr: "data-eligible-qty-count-five",
          tagsAttr: "data-eligible-qty-tags-five",
        },
        {
          thresholdAttr: "data-eligible-qty-six",
          variantsAttr: "data-eligible-qty-variantsids-six",
          countAttr: "data-eligible-qty-count-six",
          tagsAttr: "data-eligible-qty-tags-six",
        },
        {
          thresholdAttr: "data-eligible-qty-seven",
          variantsAttr: "data-eligible-qty-variantsids-seven",
          countAttr: "data-eligible-qty-count-seven",
          tagsAttr: "data-eligible-qty-tags-seven",
        },
        {
          thresholdAttr: "data-eligible-qty-eight",
          variantsAttr: "data-eligible-qty-variantsids-eight",
          countAttr: "data-eligible-qty-count-eight",
          tagsAttr: "data-eligible-qty-tags-eight",
        },
      ];

      for (const offer of qtyOffers) {
        const threshold = Number(cartAjax.getAttribute(offer.thresholdAttr));
        const count = Number(cartAjax.getAttribute(offer.countAttr));
        const variants =
          cartAjax
            .getAttribute(offer.variantsAttr)
            ?.split(",")
            .map((v) => v.trim()) || [];

        if (!threshold || !count || !variants.length) continue;

        // const thresholdMet = tagPresenceCount >= threshold;
        const tags =
          cartAjax
            .getAttribute(offer.tagsAttr)
            ?.split(",")
            .map((t) => t.trim()) || [];

        const taggedQty = getTaggedQty(tags);

        const thresholdMet = taggedQty >= threshold;

        const offerFreebiesInCart = currentFreebies.filter((item) =>
          variants.includes(String(item.id))
        );

        if (!thresholdMet) {
          offerFreebiesInCart.forEach((item) => {
            variantsToRemove.push(item.key);
          });
          continue;
        }

        if (offerFreebiesInCart.length >= count) continue;

        const needed = count - offerFreebiesInCart.length;
        const usedIds = offerFreebiesInCart.map((i) => String(i.id));

        const availableFallbacks = await getAvailableVariants(
          variants.filter((id) => !usedIds.includes(id)),
          needed,
          cartVariantIds
        );

        variantsToAdd.push(...availableFallbacks);
      }

      /* ======================================================
        OFFER 13 — SPECIAL vs NORMAL FREEBIE (UNIFIED, MUTUALLY EXCLUSIVE)
        Decision tree (evaluated once, only one freebie can win):
          1. nonSpecialTaggedQty >= threshold  → normal freebie wins
          2. totalTaggedQty >= threshold AND special product in cart → special freebie wins
          3. Otherwise → remove both
        "nonSpecialTaggedQty" excludes the special trigger variant's qty so that
        adding the special product alone cannot satisfy the normal-freebie branch.
      ====================================================== */
      const specialTriggerVid    = cartAjax.getAttribute("data-special-freebie-trigger-vid")?.trim();
      const specialTriggerTagRaw = cartAjax.getAttribute("data-special-freebie-trigger-tag")?.trim();
      const specialTriggerQty    = Number(cartAjax.getAttribute("data-special-freebie-trigger-qty")?.trim()) || 1;
      const specialFreebieVid    = cartAjax.getAttribute("data-special-freebie-vid")?.trim();
      const normalFreebieVid     = cartAjax.getAttribute("data-normal-freebie-vid")?.trim();

      if (specialFreebieVid || normalFreebieVid) {
        const triggerTags = specialTriggerTagRaw
          ? specialTriggerTagRaw.split(",").map(t => t.trim()).filter(Boolean)
          : [];
        const totalTaggedQty = triggerTags.length ? getTaggedQty(triggerTags) : 0;

        // Qty of the special trigger variant already in cart (non-freebie lines only)
        const specialTriggerItemQty = specialTriggerVid
          ? cart.items.reduce((sum, item) =>
              String(item.id) === specialTriggerVid && !item.properties?._freebieLineItem
                ? sum + item.quantity : sum, 0)
          : 0;

        const specialInCart = specialTriggerItemQty > 0;
        // Tagged qty from non-special-trigger items only
        const nonSpecialTaggedQty = Math.max(0, totalTaggedQty - specialTriggerItemQty);

        const specialFreebieInCart = specialFreebieVid
          ? currentFreebies.find(item => String(item.id) === specialFreebieVid)
          : null;
        const normalFreebieInCart = normalFreebieVid
          ? currentFreebies.find(item => String(item.id) === normalFreebieVid)
          : null;

        const anyFreebieInCart = normalFreebieInCart || specialFreebieInCart;

        if (nonSpecialTaggedQty >= specialTriggerQty) {
          // Branch 1: non-special items alone satisfy threshold.
          // First-come-first-served: if any freebie is already in cart keep it, never swap.
          // Only add normal freebie when the slot is completely empty.
          if (!anyFreebieInCart && normalFreebieVid) {
            const available = await getAvailableVariants([normalFreebieVid], 1, cartVariantIds);
            if (available.length) variantsToAdd.push(normalFreebieVid);
          }
        } else if (specialFreebieVid && totalTaggedQty >= specialTriggerQty && specialInCart) {
          // Branch 2: threshold met only because special product is included.
          // First-come-first-served: if any freebie is already in cart keep it, never swap.
          // Only add special freebie when the slot is completely empty.
          if (!anyFreebieInCart) {
            const available = await getAvailableVariants([specialFreebieVid], 1, cartVariantIds);
            if (available.length) variantsToAdd.push(specialFreebieVid);
          }
        } else {
          // Branch 3: threshold not met → remove whichever freebie is present
          if (normalFreebieInCart)  variantsToRemove.push(normalFreebieInCart.key);
          if (specialFreebieInCart) variantsToRemove.push(specialFreebieInCart.key);
        }
      }

      /* ------------------ ADD FREEBIES ------------------ */
      if (variantsToAdd.length) {
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [...new Set(variantsToAdd)].map((id) => ({
              id,
              properties: { _freebieLineItem: "true" },
            })),
            sections: "cart-drawer,cart-icon-bubble",
            sections_url: "/cart",
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            const myCart =
              document.querySelector("cart-notification") ||
              document.querySelector("cart-drawer");
            myCart.renderContents(data);
            CartDrawer.setBusy(false);
            if(data.items.length > 0 && document.querySelector('cart-drawer').getAttribute("data-show-confettiShooter") == 'true') {
              setTimeout(() => {
                window.confettiShooter();
              }, 600);
            }
          }).catch(() => CartDrawer.setBusy(false));
      }

      /* ------------------ REMOVE FREEBIES ------------------ */
      if (variantsToRemove.length) {
        const updates = {};
        [...new Set(variantsToRemove)].forEach((key) => (updates[key] = 0));

        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            updates,
            sections: "cart-drawer,cart-icon-bubble",
            sections_url: "/cart",
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            const myCart =
              document.querySelector("cart-notification") ||
              document.querySelector("cart-drawer");
            myCart.renderContents(data);
            CartDrawer.setBusy(false);
          })
          .catch(() => CartDrawer.setBusy(false));
      }

      if (!variantsToAdd.length && !variantsToRemove.length) {
        CartDrawer.setBusy(false);
      }
    }

    /* ------------------ AVAILABILITY CHECK ------------------ */
    async function getAvailableVariants(variantIds, count, cartVariantIds) {
      const available = [];

      for (const id of variantIds) {
        if (available.length >= count) break;
        if (cartVariantIds.includes(id)) continue;

        try {
          const res = await fetch(`/variants/${id}.js`);
          if (!res.ok) continue;

          const variant = await res.json();
          if (variant.available) {
            available.push(String(id));
          }
        } catch (e) {
          console.error("Variant availability failed", id);
        }
      }

      return available;
    }

    function getTaggedQty(requiredTags = []) {
      if (!requiredTags.length) return 0;

      let count = 0;

      document
        .querySelectorAll("cart-drawer .cart-item")
        .forEach((item) => {
          const variantTags = item.dataset.variantTags;
          if (!variantTags) return;

          const hasMatchingTag = requiredTags.some((tag) =>
            variantTags.includes(tag)
          );

          if (!hasMatchingTag) return;

          const qtyInput = item.querySelector("quantity-input input");
          if (qtyInput) {
            count += parseInt(qtyInput.value || 0, 10);
          }
        });

      return count;
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const sections = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];

    if (document.getElementById('quantity-message')) {
      sections.push({
        id: 'quantity-message',
        section: 'quantity-message',
        selector: '#quantity-message'
      });
    }

    return sections;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


//checkout spinner 
let cartCheckout = document.querySelector('#CartDrawer-Checkout')?.addEventListener('click',()=>{
  document.querySelector('#checkout_text_icon').style.display="none";
  document.querySelector('#loader_wrapper').style.display ="flex";
})

class customRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    this.showCart = true;
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.removeBundleFromCart();
    });
  }

  removeBundleFromCart() {
    const removeButton = this.querySelector('button');

    if (!removeButton || !removeButton.dataset.removehasaddictedtogoodbox) {
      console.error("Remove button or dataset is missing.");
      return;
    }

    let variantIds = removeButton.dataset.removehasaddictedtogoodbox.split(', ');

    let updates = {};
    variantIds.forEach((id) => {
      if(id !== ""){
        let variantId = id.split(":")[0].trim();
        updates[variantId] = 0;
      }
    });

    const payload = {
      updates: updates,
      sections: this.cart.getSectionsToRender().map(({ id }) => id),
      sections_url: window.location.pathname
    };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
    .then(response => response.json())
    .then(data => {
      this.cart.renderContents(data, this.showCart);
    })
    .catch(error => {
      console.error("Error updating cart:", error.message);
    });
  }
}

customElements.define('custom-remove-button', customRemoveButton);

class BundleEdit extends HTMLElement {
  constructor(){
    super();
  }

  connectedCallback(){
    this.productsList = JSON.parse(this.dataset.bundleArray);
    this.buildABoxPage = window.location.origin + this.dataset.collection;
    this.uniqueProperty = this.dataset.uniqueProperty;

    this.addEventListener('click', this.editBundleItems.bind(this));
  }

  editBundleItems(event){
    event.preventDefault();
    localStorage.setItem('boxProducts', JSON.stringify(this.productsList));
    
    const data = {
      bundleItems: JSON.stringify(this.productsList),
      uniqueProperty: this.uniqueProperty
    };

    localStorage.setItem('updateBundleProduct', JSON.stringify(data));
    window.location.href = this.buildABoxPage;
  }
}

customElements.define('bundle-edit', BundleEdit);